import { render, staticRenderFns } from "./ResourceFormCreate.vue?vue&type=template&id=75736bb1&scoped=true"
import script from "./ResourceFormCreate.vue?vue&type=script&lang=ts"
export * from "./ResourceFormCreate.vue?vue&type=script&lang=ts"
import style0 from "./ResourceFormCreate.vue?vue&type=style&index=0&id=75736bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75736bb1",
  null
  
)

export default component.exports